import Link from "next/link"
import { getShortenedUrlwithGeneral } from "@/utils/helper"
import { useEffect, useId, useState } from "react"
import { getConfig } from "@/constants/config"
import classes from "./index.module.scss"

function PromoBanner({ promoBanner }) {
  const bannerId = useId()
  const [general, setGeneral] = useState()
  useEffect(() => {
    const configFn = async () => {
      const { general } = await getConfig()
      setGeneral(general)
    }
    configFn()
  }, [])

  const getColorClass = appliedCssClassNames => {
    if (appliedCssClassNames.includes("bg-warm-gray-medium")) {
      return classes?.bannerGrey
    }
    if (appliedCssClassNames.includes("bg-medium-plumb")) {
      return classes?.bannerPlumb
    }
    if (appliedCssClassNames.includes("bg-dark-blue-two")) {
      return classes?.bannerBlue
    }
    return ""
  }

  return (
    <div className={classes.promoBanner}>
      {promoBanner?.content?.map((banner, index1) => {
        let colorClass = getColorClass(banner.appliedCssClassNames)
        return (
          <div
            key={index1}
            className={`${classes.promoBannerMain} ${colorClass}`}
          >
            <div
              id={`${bannerId}-content-${index1}`}
              className={classes.promoBannerContent}
            >
              {banner.content}
            </div>
            {banner.CTAs &&
              banner.CTAs.map((item, index2) => (
                <Link
                  key={index2}
                  href={getShortenedUrlwithGeneral(item.href, general)}
                  className={classes.promoBannerLink}
                  aria-labelledby={
                    banner.content?.trim()
                      ? `${bannerId}-link-${index1}-${index2} ${bannerId}-content-${index1}`
                      : undefined
                  }
                >
                  <span id={`${bannerId}-link-${index1}-${index2}`}>
                    {item.text}
                  </span>
                </Link>
              ))}
          </div>
        )
      })}
    </div>
  )
}
export default PromoBanner
